
<template>
  
  <!-- TOP BAR -->
  <section class="hidden md:flex bg-white dark:bg-gray-800 p-6 rounded-lg shadow space-y-4 top-0 sticky">
    <button
      class="ms-auto"
      @click="userLogout"
    >
      Salir
    </button>
  </section>
  
  <!-- Título visible en desktop -->
  <div class="hidden md:flex justify-between items-center">
    <h1 class="text-3xl font-bold">Mi Marca</h1>
  </div>

  <!-- Bloque Info Restaurante -->
  <section class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow space-y-4">
    <h2 class="text-2xl font-semibold mb-4">Información del restaurante</h2>
    <div class="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6">
      <div class="w-24 h-24 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center">
        <span class="text-gray-400 text-sm">Logo</span>
      </div>
      <div class="flex-1 space-y-2 w-full">
        <div>
          <label class="block text-sm font-medium text-gray-600 dark:text-gray-300">Nombre del restaurante</label>
          <input type="text" value="Restaurante La Sabrosura" class="mt-1 w-full p-2 border rounded dark:bg-gray-900 dark:border-gray-700">
        </div>
        <div class="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3">
          <button class="bg-[#ff642e] text-white px-4 py-2 rounded hover:bg-orange-500">Actualizar Información</button>
          <button class="border px-4 py-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700">Cambiar Logo</button>
        </div>
      </div>
    </div>
  </section>

  <!-- Bloque de gráficas -->
  <section class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
    <h2 class="text-2xl font-semibold mb-4">Estadísticas del negocio</h2>
    <div class="w-full h-64 bg-gray-100 dark:bg-gray-700 rounded flex items-center justify-center">
      <span class="text-gray-400">[Espacio para gráficos]</span>
    </div>
  </section>
</template>